import { render, staticRenderFns } from "./LoadingMsg.vue?vue&type=template&id=ed8cbe28&scoped=true&"
import script from "./LoadingMsg.vue?vue&type=script&lang=js&"
export * from "./LoadingMsg.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMsg.vue?vue&type=style&index=0&id=ed8cbe28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8cbe28",
  null
  
)

export default component.exports